import './rich-text.scss'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'

export const RichText: FC<GridElement<string>> = props => {
    return <div className="rich-text" dangerouslySetInnerHTML={{ __html: props.value }} />
}
